<template>
  <v-app id="inspire">
    <router-view v-if="$route.path === `/${$i18n.locale}/login` ? true : false">
      <router-link :to="`/${$i18n.locale}/` + 'login'">{{ $t("login.login") }}</router-link>
    </router-view>

    <div v-if="$route.path === `/${$i18n.locale}/login` ? false : true">
      <v-navigation-drawer v-model="drawer" app width="250">
        <v-list dense>
          <v-list-item-group v-model="selectedItem" color="primary">
            <!-- Testing -->
            <!-- Point type recieved == EVCS OR nothing recieved back, rendering by roles (compatibility)  -->
            <!--<template v-if="point.type === type[0] || point.type === ''"> DEBUG EVCS <br /></template> -->

            <!-- Point type recieved == EESS OR nothing recieved back, rendering by roles (compatibility) -->
            <!--<template v-if="point.type === type[1] || point.type === ''"> DEBUG EESS <br /></template> -->

            <!-- Point type recieved == ESCB OR nothing recieved back, rendering by roles (compatibility) -->
            <!--<template v-if="point.type === type[2] || point.type === ''"> DEBUG ESCB <br /> </template> -->

            <br />
            <br />
            <div class="d-flex justify-center ma-2">
              <strong>{{ vuexApp.name }}</strong>
            </div>
            <div class="d-flex justify-center ma-2">
              <template v-if="account.user != null"> {{ account.user.firstName }} {{ account.user.lastName }} </template>
            </div>

            <template v-if="point.projectName != ''">
              <div class="d-flex justify-center small-div" :style="{ color: this.$vuetify.theme.dark ? 'white' : 'gray' }">
                <strong>{{ point.projectName }} </strong>
              </div>
            </template>

            <template v-if="point.objectName != ''">
              <div class="d-flex justify-center small-div" :style="{ color: this.$vuetify.theme.dark ? 'white' : 'gray' }">
                <strong>
                  {{ point.objectName }}
                </strong>
              </div>
            </template>

            <template v-if="point.serialNumber != ''">
              <div class="d-flex justify-center very-small-div" :style="{ color: this.$vuetify.theme.dark ? 'white' : 'gray' }">
                <i>
                  {{ point.serialNumber }}
                </i>
              </div>
            </template>

            <div class="d-flex justify-center ma-2 text-caption font-italic" :style="this.$vuetify.theme.dark ? 'color: white;' : 'color: gray'">
              <template v-if="account.user != null"> {{ account.user.appurl }} </template>
            </div>

            <!--        
              <template v-if="$route.path === `/${$i18n.locale}/serviceapp` ? false : true"> 
            -->

            <template v-if="this.account.user !== null">
              <hr />
              <hr />
              <v-list-item v-for="item in product.all" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <template v-if="this.account.user != null">
              <template v-if="'roles' in this.account.user">
                <!-- Point type recieved == ESCB OR nothing recieved back, rendering by roles (compatibility) -->
                <template v-if="point.type === type[2]">
                  <!-- 
                  <template v-if="this.account.user.roles[2] === 'EC_SHARING'">
                  
                  </template>
                  -->
                  <hr />
                  <hr />
                  <div class="d-flex justify-center ma-4">
                    <v-icon class="mx-1"> mdi-weather-sunny </v-icon>
                    <v-icon class="mx-1"> mdi-share-outline </v-icon>
                    <v-icon class="mx-1"> mdi-battery-charging-high </v-icon>
                  </div>
                  <hr />

                  <v-list-item v-for="item in product.home.sharing" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                    <v-list-item-icon>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <!-- Point type recieved == EESS OR nothing recieved back, rendering by roles (compatibility) -->
                <template v-if="point.type === type[1] || point.type === ''">
                  <template v-if="this.account.user.roles[0] != null">
                    <hr />
                    <hr />

                    <div class="d-flex justify-center ma-4">
                      <v-icon class="mx-1"> mdi-solar-power </v-icon>
                      <v-icon class="mx-1"> mdi-solar-panel </v-icon>
                      <v-icon class="mx-1"> mdi-battery-charging-100 </v-icon>
                    </div>
                    <hr />
                  </template>

                  <template v-if="this.account.user.roles[0] === 'EC_ADMIN'">
                    <v-list-item v-for="item in product.home.admin" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                      <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <template v-if="this.account.user.roles[0] === 'EC_SERVICE'">
                    <v-list-item v-for="item in product.home.service" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                      <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <template v-if="this.account.user.roles[0] === 'EC_USER'">
                    <v-list-item v-for="item in product.home.user" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                      <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </template>

                <!-- Point type recieved == EVCS OR nothing recieved back, rendering by roles (compatibility)  -->
                <template v-if="point.type === type[0] || point.type === ''">
                  <template v-if="this.account.user.roles[1] != null">
                    <hr />
                    <hr />

                    <div class="d-flex justify-center ma-4">
                      <!--  Charger -->

                      <v-icon class="mx-1"> mdi-ev-station </v-icon>
                      <v-icon class="mx-1"> mdi-battery-charging-100 </v-icon>
                      <v-icon class="mx-1"> mdi-car-electric </v-icon>
                    </div>
                    <hr />
                  </template>

                  <template v-if="this.account.user.roles[1] === 'EVC_ADMIN'">
                    <v-list-item v-for="item in product.charger.admin" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                      <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <template v-if="this.account.user.roles[1] === 'EVC_SERVICE'">
                    <v-list-item v-for="item in product.charger.service" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                      <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <template v-if="this.account.user.roles[1] === 'EVC_USER'">
                    <v-list-item v-for="item in product.charger.user" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                      <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </template>
              </template>
            </template>

            <template v-if="this.account.user !== null">
              <!-- Point type recieved == EVCS OR EESS OR nothing recieved back, rendering by roles (compatibility)  -->
              <!-- No need for ESCB-->
              <template v-if="point.type === type[0] || point.type === type[1] || point.type === ''">
                <hr />
                <hr />

                <!--  Global -->
                <div class="d-flex justify-center ma-4">
                  <v-icon class="mx-1"> mdi-wrench </v-icon>
                  <v-icon class="mx-1"> mdi-cog-outline </v-icon>
                  <v-icon class="mx-1"> mdi-card-account-phone-outline </v-icon>
                </div>

                <hr />

                <v-list-item v-for="item in product.others" :key="item.title" :to="`/${$i18n.locale}/` + item.route" color="primary">
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>

            <template v-if="point.type === ''">
              <hr />
              <hr />
              <div class="d-flex justify-center ma-4">
                <!--  Charger -->
                <v-icon class="mx-1"> mdi-desktop-classic </v-icon>
                <v-icon class="mx-1"> mdi-developer-board </v-icon>
                <v-icon class="mx-1"> mdi-dev-to </v-icon>
              </div>
              <hr />
              <v-list-item :to="`/${$i18n.locale}/serviceapp`" color="primary">
                <v-list-item-icon>
                  <v-icon>mdi-developer-board</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("app.service") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr />
              <hr />
            </template>
            <template v-else>
              <hr />
            </template>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar app color="primary" dark hide-on-scroll scroll-threshold="0" class="post">
        <v-row no-gutters>
          <v-col cols="2" class="d-flex justify-start">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
          </v-col>

          <v-col cols="8" class="d-flex justify-center">
            <b class="text-caption" style="color: rgba(255, 255, 255, 0.3)">BUILD: {{ vuexApp.build }}</b>
          </v-col>

          <v-col cols="2" class="d-flex justify-end">
            <AccountMenu />
          </v-col>
        </v-row>
      </v-app-bar>

      <v-main>
        <v-container fluid>
          <router-view />
        </v-container>
      </v-main>
    </div>
  </v-app>
</template>

<script>
  import { type } from "./components/products/filters.js";

  import AccountMenu from "./components/account/AccountMenu.vue";
  import { mapState, mapActions } from "vuex";

  export default {
    name: "App",
    props: {
      source: String,
    },
    components: {
      AccountMenu,
    },
    data() {
      return {
        selectedItem: 0,
        darkTheme: false,

        type: type,

        product: {
          all: [
            {
              title: "app.products",
              icon: "mdi-map-search",
              route: "products",
            },
          ],
          home: {
            sharing: [
              {
                title: "app.escb.dashboard", //
                icon: "mdi-monitor-dashboard", //
                route: "escb-dashboard", //
              },
              {
                title: "app.escb.piecharts", //
                icon: "mdi-chart-arc", //
                route: "escb-piecharts", //
              },
              {
                title: "app.escb.charts", //
                icon: "mdi-chart-bar", //
                route: "escb-charts", //
              },
              {
                title: "app.savings", //
                icon: "mdi-piggy-bank-outline", //
                route: "escb-savings", //
              },
            ],
            admin: [
              {
                title: "app.dashboardlite", //
                icon: "mdi-view-dashboard", //
                route: "eess-basic", //
              },
              {
                title: "app.dashboard",
                icon: "mdi-view-dashboard-variant",
                route: "eess-dashboard",
              },
              {
                title: "app.charts2", //
                icon: "mdi-chart-arc", //
                route: "eess-piecharts2",
              },
              {
                title: "app.charts", //
                icon: "mdi-chart-bar", //
                route: "eess-charts", //
              },
              {
                title: "app.powerplant", //
                icon: "mdi-solar-power", //
                route: "eess-powerplant", //
              },
              {
                title: "app.ppds", //
                icon: "mdi-transmission-tower", //
                route: "eess-ppds", //
              },
              {
                title: "app.savings", //
                icon: "mdi-piggy-bank-outline", //
                route: "eess-savings", //
              },
              {
                title: "app.battery", //
                icon: "mdi-battery-sync", //
                route: "eess-battery", //
              },
              {
                title: "app.events", //
                icon: "mdi-script-text-outline", //
                route: "eess-events", //
              },
              {
                title: "app.calibration", //
                icon: "mdi-tape-measure", //
                route: "eess-calibration", //
              },
              {
                title: "app.advanced", //
                icon: "mdi-rotate-orbit", //
                route: "eess-advanced", //
              },
              /*
            {
              title: "app.upgrade", //
              icon: "mdi-update", //
              route: "upgrade", //
            },
            {
              title: "app.notifications", //
              icon: "mdi-volume-high", //
              route: "notifications", //
            },
            */
              {
                title: "app.userinterface", //
                icon: "mdi-video-input-component", //
                route: "eess-userinterface", //
              },
              /*
            {
              title: "app.qrreader", //
              icon: "mdi-qrcode-scan", //
              route: "qrreader", //
            },
            */
            ],
            service: [
              {
                title: "app.dashboardlite", //
                icon: "mdi-view-dashboard", //
                route: "eess-basic", //
              },
              {
                title: "app.dashboard", //
                icon: "mdi-view-dashboard", //
                route: "eess-dashboard", //
              },
              {
                title: "app.charts2", //
                icon: "mdi-chart-arc", //
                route: "eess-piecharts2", //
              },
              {
                title: "app.charts", //
                icon: "mdi-chart-bar", //
                route: "eess-charts", //
              },
              {
                title: "app.powerplant", //
                icon: "mdi-solar-power", //
                route: "eess-powerplant", //
              },
              {
                title: "app.ppds", //
                icon: "mdi-transmission-tower", //
                route: "eess-ppds",
              },
              {
                title: "app.savings", //
                icon: "mdi-piggy-bank-outline", //
                route: "eess-savings", //
              },
              {
                title: "app.battery", //
                icon: "mdi-battery-sync", //
                route: "eess-battery",
              },
              {
                title: "app.events", //
                icon: "mdi-script-text-outline", //
                route: "eess-events", //
              },
              {
                title: "app.calibration", //
                icon: "mdi-tape-measure", //
                route: "eess-calibration", //
              },
              {
                title: "app.advanced", //
                icon: "mdi-rotate-orbit", //
                route: "eess-advanced", //
              },
              {
                title: "app.userinterface", //
                icon: "mdi-video-input-component", //
                route: "eess-userinterface", //
              },
              /*
            {
              title: "app.upgrade", //
              icon: "mdi-update", //
              route: "upgrade", //
            },
            {
              title: "app.notifications", //
              icon: "mdi-volume-high", //
              route: "notifications",
            },
            */
            ],
            user: [
              {
                title: "app.dashboardlite", //
                icon: "mdi-view-dashboard", //
                route: "eess-basic", //
              },
              {
                title: "app.dashboard", //
                icon: "mdi-view-dashboard-variant", //
                route: "eess-dashboard", //
              },
              {
                title: "app.charts2", //
                icon: "mdi-chart-arc", //
                route: "eess-piecharts2", //
              },
              {
                title: "app.charts", //
                icon: "mdi-chart-bar", //
                route: "eess-charts", //
              },
              {
                title: "app.powerplant", //
                icon: "mdi-solar-power", //
                route: "eess-powerplant", //
              },
              {
                title: "app.ppds", //
                icon: "mdi-transmission-tower", //
                route: "eess-ppds", //
              },
              {
                title: "app.savings", //
                icon: "mdi-piggy-bank-outline", //
                route: "eess-savings", //
              },
              {
                title: "app.battery", //
                icon: "mdi-battery-sync", //
                route: "eess-battery", //
              },
              /*
            {
              title: "app.events", //
              icon: "mdi-script-text-outline", //
              route: "eess-events", //
            },
            */
              {
                title: "app.calibration", //
                icon: "mdi-tape-measure", //
                route: "eess-calibration", //
              },
              {
                title: "app.advanced", //
                icon: "mdi-rotate-orbit", //
                route: "eess-advanced", //
              },
              /*
            {
              title: "app.upgrade", //
              icon: "mdi-update", //
              route: "upgrade", //
            }, */
              /*
             {
              title: "app.notifications", //
              icon: "mdi-volume-high", //
              route: "notifications", //
            },
            */
              {
                title: "app.userinterface",
                icon: "mdi-video-input-component",
                route: "eess-userinterface",
              },
            ],
          },
          charger: {
            admin: [
              {
                title: "app.evcs.dashboard", //
                icon: "mdi-car-electric", //
                route: "evcs-dashboard", //
              },
            ],
            service: [
              {
                title: "app.evcs.dashboard", //
                icon: "mdi-car-electric", //
                route: "evcs-dashboard", //
              },
            ],
            user: [
              {
                title: "app.evcs.dashboard", //
                icon: "mdi-car-electric", //
                route: "evcs-charger", //
              },
            ],
          },
          others: [
            {
              title: "app.parameters", //
              icon: "mdi-wrench-outline", //
              route: "parameters", //
            },
            {
              title: "app.settings", //
              icon: "mdi-cog", //
              route: "settings", //
            },
            {
              title: "app.support", //
              icon: "mdi-cellphone-basic", //
              route: "support", //
            },
          ],
        },

        item: null,

        drawer: null,
      };
    },
    computed: {
      ...mapState({
        vuexApp: (state) => state.app,
        alert: (state) => state.alert,
        account: (state) => state.account,
        point: (state) => state.point,
      }),
    },
    created() {
      window.addEventListener("resize", this.$store.commit("device/setWindowWidth"));

      this.vuexUpdateName("EnergyCloud"); // Název Aplikace
      //this.vuexUpdateName("Energy Diagnostic System");
      this.vuexUpdateBuild("202503101416"); // Číslo Buildu
    },
    mounted() {
      if (localStorage.getItem("themeColor") !== null) {
        this.changeColorTheme(localStorage.getItem("themeColor"));
      }
      if (localStorage.getItem("lang") !== null) {
        this.setLocale(localStorage.getItem("lang"));
      }
      if (localStorage.getItem("darkTheme") !== null) {
        if (localStorage.getItem("darkTheme") === "true") {
          this.$vuetify.theme.dark = true;
        } else if (localStorage.getItem("darkTheme") === "false") {
          this.$vuetify.theme.dark = false;
        }
      }
    },
    methods: {
      ...mapActions({
        clearAlert: "alert/clear",
        vuexUpdateName: "app/updateName",
        vuexUpdateBuild: "app/updateBuild",
      }),
      setLocale(locale) {
        localStorage.setItem("lang", locale);
        this.$i18n.locale = locale;
        this.$router.push({
          params: { lang: locale },
        });
      },
      changeColorTheme(String) {
        localStorage.setItem("themeColor", String);
        this.$vuetify.theme.themes.light.primary = String;
        this.$vuetify.theme.themes.light.accent = String;
        this.$vuetify.theme.themes.dark.primary = String;
        this.$vuetify.theme.themes.dark.accent = String;
      },
    },
  };
</script>

<style scoped>
  .small-div {
    font-size: 0.75rem;
    line-height: 0.9rem;
    margin: 4px;
  }

  .very-small-div {
    font-size: 0.65rem;
    line-height: 0.9rem;
    margin: 4px;
  }

  .post {
    padding: 12px;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
  /* .list:hover {
  background: green;
}
.list:active {
  background: yellow;
} */
  /* @supports(padding:max(0px)) {
    body, header, footer {
        padding-left: min(0vmin, env(safe-area-inset-left));
        padding-right: min(0vmin, env(safe-area-inset-right));
    }
} */

  /*  .safearea {
    padding: 12px;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
}  */

  /* @supports (padding: max(0px)) {
  .safearea {
    padding-left: max(12px, env(safe-area-inset-left));
    padding-right: max(12px, env(safe-area-inset-right));
  }
} */

  /* @supports(padding:max(0px)) {
    body, header, footer {
        padding-left: min(0vmin, env(safe-area-inset-left));
        padding-right: min(0vmin, env(safe-area-inset-right));
    }
} */

  /* @supports (padding: max(0px)) {
  .container {
    padding-left: calc(max(12px, env(safe-area-inset-left)));
    padding-right: calc(max(12px, env(safe-area-inset-right)));
  }
}

.content {
  padding: 16px;
  padding-left: env(safe-area-inset-left); /* Apply safe area */
  /*padding-right: env(safe-area-inset-right);
} */

  /* scss snippet */

  /* @media only screen and (orientation: portrait) {
    body {
        .shrink {
            width: 95%;
        }
    }
}

@media only screen and (orientation: landscape) {
    body {
        .shrink {
            width: 90%;     
        }
    }
}

.center {
    text-align: center;
    margin: 0 auto;
} */

  /* Mouseover effect */
  /* .v-card {
  transition: opacity 0.4s ease-in-out;
}
.v-card:not(.on-hover) {
  opacity: 0.6;
} */
  /* For phones there is not usefull mouseover effect so i'll disable that shiet*/
  /* @media (max-width: 400px) {
  .v-card:not(.on-hover) {
    opacity: 1;
  }
} */
  /* .show-btns {
  color: rgba(255, 255, 255, 1) !important;
} */
</style>
